module.exports = __webpack_public_path__ + "static/media/12.38a72361.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/12.jpg
// module id = 187
// module chunks = 0